export default "__VITE_ASSET__CxG0PBGQ__"